export const ATTRIBUTION_POLICIES = {
    CLICK_FIRST: 'CLICK_FIRST',
    LAST_TOUCH: 'LAST_TOUCH',
    COUPON_ALWAYS_CREDIT: 'COUPON_ALWAYS_CREDIT'
};

export function attributionPolicyOptions(vm) {
    return [
        { label: vm.$t('attribution_click_first'), value: ATTRIBUTION_POLICIES.CLICK_FIRST },
        { label: vm.$t('attribution_last_touch'), value: ATTRIBUTION_POLICIES.LAST_TOUCH },
        { label: vm.$t('attribution_coupon_always_credit'), value: ATTRIBUTION_POLICIES.COUPON_ALWAYS_CREDIT }
    ];
}

export function attributionPolicyLabel(vm, value) {
    const match = attributionPolicyOptions(vm).find((option) => option.value === value);
    return match ? match.label : value || vm.$t('attribution_last_touch');
}

export function formatAttributionPolicy(vm, value) {
    if (!value) {
        return '';
    }

    return attributionPolicyLabel(vm, value);
}
